<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-toast-notification></app-toast-notification>
<app-notification-panel></app-notification-panel>
<app-help-panel></app-help-panel>